var _defs, _g, _circle, _circle2, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXtraceLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 62",
    role: "img",
    "aria-label": "XTrace Memory",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "XTrace Memory") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "xtGrad",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#a78bfa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#6366f1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "url(#xtGrad)",
    strokeWidth: 3.4,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 8 L76 40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 8 L44 40"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 24,
    r: 8.6,
    fill: "#0b1120",
    stroke: "url(#xtGrad)",
    strokeWidth: 3.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 24,
    r: 3.2,
    fill: "url(#xtGrad)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 56,
    textAnchor: "middle",
    fontFamily: "Inter, 'Segoe UI', Helvetica, Arial, sans-serif",
    fontSize: 15.5,
    fontWeight: 700,
    fill: "#e5e7eb",
    letterSpacing: 0.4
  }, "XTrace")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXtraceLogo);
export default __webpack_public_path__ + "static/media/xtrace-logo.8fe8a3c0c7f1b9bd556055bbe4e90b5c.svg";
export { ForwardRef as ReactComponent };